/* eslint-disable max-lines */
/* eslint-disable react/jsx-max-depth */
/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DataTable from '../../components/elements/DataTable';
import Text from '../../components/fields/Text';
import { useDebounce } from '../../utils/hooks';
import styles from './styles.scoped.css';
// import { formatDateTime } from '../../utils/format';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import { AppContext, ToastrContext } from '../../contexts';
// import { processColor, processStatus } from './constants';
// import Tag from '../../components/elements/Tag';
// import classNames from '../../utils/classNames';
import dayjs from 'dayjs';
import moment from 'moment';
import Button from '../../components/elements/Button/Button';
import { ModalDownloadOutOfRange } from '../../components/elements/ModalDownload';
import ScrollToTop from '../../components/elements/ScrollToTop';
import AktivasiManualFilter from '../../components/fragments/AktivasiManualFilter/AktivasiManualFilter';
import ModalError from '../../components/fragments/ModalError/ModalError';
import ModalManualLoggingActivation from '../../components/fragments/ModalManualLoggingActivation/ModalManualLoggingActivation';
import {
  fetchDownload,
  fetchManualLoggings,
  seterrorUnduh,
  submissionOnProses,
  submissionProses,
  submitApprove,
  submitReject,
  successAction,
} from './actions';
import { processStatus } from './constants';
import { thousand } from '../../utils/format';
import ModalSetPassword from '../../components/fragments/ModalSetPassword';

export default function AktivasiPencatatanManual({ category }) {
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const ref = useRef(true);
  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const location = useLocation();

  const [search, setSearch] = useState('');
  const [fromDate] = useState(moment().subtract(6, 'day').toDate());
  const [toDate] = useState(moment().toDate());
  const [page, setPage] = useState(1);
  const [modalOutRangeVisible, setModalOutRangeVisible] = useState(false);
  const [modal, setModal] = useState({ isOpen: false, type: '' });
  const [modalError, setModalError] = useState(false);
  const [modalSetPassword, setModalSetPassword] = useState(false);

  const {
    dataManualLoggingActivation: { data, meta },
    dataDownload,
    isLoadingDownload,
    dataSubmissionApprove,
    dataSubmissionReject,
    dataSubmissionProses,
    isLoadingManualLoggingActivation,
    messageManualLoggingActivation,
    dataFilter,
    // isLoadingDownloadRegistrationReport,
    messageErrorUnduh,
    isLoadingErrorUnduh,
  } = useSelector((s) => s.manualLoggingActivation);

  const { dataDetailUser } = useSelector((state) => state.pageBase);

  const {
    regional = dataDetailUser.regionalId
      ? JSON.stringify([dataDetailUser.regionalId])
      : '',
    provinceId = dataDetailUser.provinceId === 'All'
      ? ''
      : dataDetailUser.provinceId,
    cityId = JSON.stringify(dataDetailUser.cities),
    districtId = dataFilter.districtId ?? '',
    villageId = '',
    outletType = '',
    activationStatus = 'all',
    wave = '',
    agenId = '',
    samId = dataDetailUser?.sam?.id
      ? JSON.stringify([dataDetailUser.sam.id])
      : '',
    sbmId = dataDetailUser?.sbm?.id
      ? JSON.stringify([dataDetailUser.sbm.id])
      : '',
    startDate = fromDate,
    endDate = toDate,
    statusDate = dataFilter?.statusDate ?? '',
  } = queryString.parse(location.search.replace('?', ''));

  // const {
  //   dataDetailUser
  // } = useSelector((s) => s.pageBase);

  useEffect(() => {
    setBreadcrumbs(['Aktivasi Pencatatan Manual']);
  }, []);

  const debounceParams = useDebounce(
    category +
      regional +
      provinceId +
      cityId +
      districtId +
      villageId +
      activationStatus +
      search +
      outletType +
      wave +
      agenId +
      samId +
      sbmId +
      startDate +
      endDate,
    500
  );
  function getAllParams(page, type = 'search', password = '') {
    const isPage = type === 'search' && { page: page ? page : 1 };
    const passwordParams = password ? { password } : null;
    let allParams = {
      regional: regional === 'All' ? '' : regional,
      provinceId: provinceId === 'All' ? '' : provinceId,
      cityId: cityId,
      districtId: districtId === 'All' ? '' : districtId,
      villageId: villageId === 'All' ? '' : villageId,
      search,
      ...isPage,
      ...passwordParams,
      startDate: moment(startDate ? startDate : fromDate).format('YYYY-MM-DD'),
      endDate: moment(endDate ? endDate : toDate).format('YYYY-MM-DD'),
      // statusStartDate: moment(statusDate ? statusDate : moment().toDate()).format('YYYY-MM-DD'),
      // statusEndDate: moment(statusDate ? statusDate : moment().toDate()).format('YYYY-MM-DD'),
      wave: wave,
      agenId: agenId,
      sbmId: sbmId || '',
      samId: samId || '',
    };

    if (outletType) {
      allParams.outletType = outletType;
    }
    if (activationStatus !== 'all') {
      allParams.activationStatus = activationStatus;
    }
    return allParams;
  }

  useEffect(() => {
    if (dataDownload && !isLoadingDownload && !ref.current) {
      setModalSetPassword(false);
      setToastr({
        desc: 'Berhasil set kata sandi pada file yang akan diunduh.',
        type: 'success',
        visible: true,
      });

      setTimeout(() => {
        let a = document.createElement('a');
        a.href = dataDownload?.fileUrl;
        a.click();
        ref.current = true;
      }, 2000);
    }
  }, [dataDownload, isLoadingDownload]);

  const handleDownload = (val) => {
    ref.current = false;
    dispatch(fetchDownload(getAllParams(1, 'download', val.password)));
  };
  const onClickDownload = () => {
    const date1 = dayjs(new Date(startDate));
    const date2 = dayjs(new Date(endDate));
    const diff = date2.diff(date1, 'day');

    if (diff <= 31) setModalSetPassword(true);
    else dispatch(seterrorUnduh());
  };

  useEffect(() => {
    if (messageErrorUnduh && !isLoadingErrorUnduh) {
      setModalError(true);
    }
  }, [messageErrorUnduh, isLoadingErrorUnduh]);

  const fetchManualLoggingList = () => {
    dispatch(fetchManualLoggings(getAllParams()));
  };

  useEffect(() => {
    dispatch(fetchManualLoggings(getAllParams(page)));
  }, [page]);

  useEffect(() => {
    setPage(1);
    fetchManualLoggingList();
    if (ref.current) {
      dispatch(fetchManualLoggings(getAllParams()));
      ref.current = false;
    }
  }, [debounceParams, fromDate, toDate, statusDate]);

  useEffect(() => {
    const getData = setTimeout(() => {
      dispatch(fetchManualLoggings(getAllParams()));
    }, 2000);
    return () => {
      clearTimeout(getData);
    };
  }, [search]);

  useEffect(() => {
    if (dataSubmissionProses?.response?.code === 200) {
      setModal({
        isOpen: true,
        type: dataSubmissionProses?.data?.isReject ? 'reject' : 'approve',
      });
      fetchManualLoggingList();
    }
  }, [dataSubmissionProses]);

  useEffect(() => {
    if (dataSubmissionApprove?.code === 200) {
      setModal({ isOpen: false, type: '' });
      fetchManualLoggingList();
    }
  }, [dataSubmissionApprove]);

  useEffect(() => {
    if (dataSubmissionReject?.code === 200) {
      setModal({ isOpen: false, type: '' });
      fetchManualLoggingList();
    }
  }, [dataSubmissionReject]);

  const handleAggree = (data) => {
    if (data.status === 'Perlu Diproses') {
      dispatch(submissionProses(data, false));
    } else {
      dispatch(submissionOnProses(data, false));
    }
  };

  const handleReject = (data) => {
    if (data.status === 'Perlu Diproses') {
      dispatch(submissionProses(data, true));
    } else {
      dispatch(submissionOnProses(data, true));
    }
  };

  const handleShowReason = (reason) => {
    setModal({ isOpen: true, type: 'reason', reason: reason });
  };

  const handleCloseModal = () => {
    dispatch(successAction({}, 'SubmissionProses'));
    setModal({ isOpen: false, type: '' });
  };

  const handleSubmitForm = (payload, type = '') => {
    if (type === 'approve') {
      const startDate = payload.startDate
        ? { startDate: payload.startDate }
        : '';
      const endDate = payload.endDate ? { endDate: payload.endDate } : '';
      const body = {
        requestId: dataSubmissionProses?.data?.requestId,
        ...startDate,
        ...endDate,
      };
      dispatch(submitApprove(body));
    } else {
      const body = {
        requestId: dataSubmissionProses?.data?.requestId,
        reason: payload?.reason,
      };

      dispatch(submitReject(body));
    }
  };

  const renderdetail = (data) => {
    if (data.status === 'Perlu Diproses') {
      return (
        <div className={styles.row}>
          <Button
            className={styles['detail-btn']}
            onClick={() => handleAggree(data)}
            style="success"
          >
            {' '}
            Setujui
          </Button>
          <Button
            className={styles['detail-btn']}
            onClick={() => handleReject(data)}
            style="danger"
          >
            {' '}
            Tolak
          </Button>
        </div>
      );
    } else if (
      data.status === 'Sedang Diproses' &&
      dataDetailUser.userId !== data.reviewerId
    ) {
      return (
        <div className={styles.row}>
          <Button
            className={styles['detail-btn']}
            // onClick={() => download()}
            disabled={true}
            style="primary"
          >
            {' '}
            Sedang Diproses
          </Button>
        </div>
      );
    } else if (
      data.status === 'Sedang Diproses' &&
      dataDetailUser.userId === data.reviewerId
    ) {
      return (
        <div className={styles.row}>
          <Button
            className={styles['detail-btn']}
            onClick={() => handleAggree(data)}
            style="success"
          >
            {' '}
            Setujui
          </Button>
          <Button
            className={styles['detail-btn']}
            onClick={() => handleReject(data)}
            style="danger"
          >
            {' '}
            Tolak
          </Button>
        </div>
      );
    } else if (data.status === 'Ditolak') {
      return (
        <div className={styles.row}>
          <Button
            className={styles['detail-btn']}
            onClick={() => handleShowReason(data.rejectedReason)}
            style="primary"
          >
            {' '}
            Lihat Alasan
          </Button>
        </div>
      );
    }
  };

  const column = [
    { heading: 'Tanggal Pengajuan', value: 'createdAt' },
    { heading: 'Nama Pangkalan LPG 3 Kg', value: 'storeName' },
    { heading: 'Tanggal Status', value: 'updatedAt' },
    { heading: 'Status', value: ({ status }) => processStatus[status] },
    {
      heading: 'Alasan Pengajuan',
      value: ({ reason, description }) =>
        reason === 'Lainnya' ? `Lainnya: ${description}` : reason,
    },
    {
      heading: 'Action',
      value: (data) => renderdetail(data),
      className: '',
    },
  ];

  if (messageManualLoggingActivation) {
    return <ErrorHandler message={messageManualLoggingActivation} />;
  }

  return (
    <div className={styles.mainRoot}>
      <AktivasiManualFilter />
      <Card className={styles['table-filter-container']}>
        <span>
          Menampilkan <strong>{thousand(meta.totalData)}</strong> data
        </span>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              disabled={isLoadingManualLoggingActivation}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
            {dataDetailUser?.userType === 'superadmin' && (
              <Button
                className={styles['upload-regist-btn']}
                onClick={onClickDownload}
              >
                <img src="assets/ic-download.svg" />
                Unduh Data
              </Button>
            )}
          </div>
        </div>
      </Card>
      <br />
      <Card className={styles.table}>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={200}
            loading={isLoadingManualLoggingActivation}
            meta={meta}
            onEndReached={() => setPage(page + 1)}
            onRefresh={fetchManualLoggingList}
            withIndex
          />
        </div>
      </Card>
      <ModalDownloadOutOfRange
        onClose={() => setModalOutRangeVisible(false)}
        open={modalOutRangeVisible}
      />
      <ModalManualLoggingActivation
        data={dataSubmissionProses}
        handleSubmit={handleSubmitForm}
        onClose={handleCloseModal}
        open={modal.isOpen}
        reason={modal?.reason}
        type={modal.type}
      />
      <ModalError open={modalError} setModalError={setModalError} />

      <ModalSetPassword
        handledClose={() => setModalSetPassword(false)}
        handledDownload={handleDownload}
        isLoading={isLoadingDownload}
        open={modalSetPassword}
      />
      <ScrollToTop />
    </div>
  );
}

AktivasiPencatatanManual.propTypes = {
  category: PropTypes.shape({
    categoryId: PropTypes.string,
    unit_name: PropTypes.string,
    unit_symbol: PropTypes.string,
  }),
};
